import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';

import { AppState } from '@app/core/reducers';
import { environment } from '@app/env-service';

import { AuthService } from '../services/auth.service';

import { AuthActionTypes, LogOut, UserLoaded } from './auth.actions';

@Injectable()
export class AuthEffects {
  logout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<LogOut>(AuthActionTypes.LOGOUT),
        tap((action) => {
          this.AuthSvc.logout();
        }),
      ),
    { dispatch: false },
  );

  // @Effect({ dispatch: false })
  // login$ = this.actions$.pipe(
  // 	ofType<LogIn>(AuthActionTypes.LOGIN),
  // 	tap(action => {
  // 		console.log('Login Effect');
  // 		console.log(action);
  // 		localStorage.setItem(environment.accessTokenKey, action.payload.authToken);
  // 		this.store.dispatch(new UserRequested());
  // 	}),
  // );

  // @Effect({ dispatch: false })
  // loginSuccess$ = this.actions$.pipe(
  // 	ofType<LogInSuccess>(AuthActionTypes.LOGIN_SUCCESS),
  // 	tap(action => {
  // 		console.log('Login success effect');
  // 		console.log(action);
  // 		localStorage.setItem(environment.accessTokenKey, action.payload.authToken);
  // 		this.store.dispatch(new UserRequested());
  // 	}),
  // );

  private returnUrl :string;

  constructor(
    private actions$ :Actions,
    private router :Router,
    private AuthSvc :AuthService,
    private store :Store<AppState>,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.returnUrl = event.url;
      }
    });
  }
}
